/**
 * Get initials from a full name
 * @param {string} name - Full name
 * @returns {string} Uppercase initials (max 2 characters)
 */
export const getInitials = (name) => {
  if (!name) return "?";
  const parts = name.split(" ");
  if (parts.length >= 2) {
    return `${parts[0].charAt(0)}${parts[1].charAt(0)}`.toUpperCase();
  }
  return name.substring(0, 2).toUpperCase();
};